import FormDrawer from '../../form-drawer/form-drawer.component';
import { useTranslation } from 'react-i18next';
import { useACHLocationForm } from 'components/forms/ach-copy-location-form/ach-copy-location-form.hooks';
import ACHCopyLocationForm from 'components/forms/ach-copy-location-form/ach-copy-location-form.component';
import { useCopyACHLocationMutation } from 'api/giftcard-ach-service/giftcard-ach-service';
import { useNavigate } from 'react-router-dom';

type ACHCopyFromDrawerProps = {
  open: boolean;
  close: () => void;
  locationId: string;
};

const ACHCopyFromDrawer = ({
  open,
  close,
  locationId,
}: ACHCopyFromDrawerProps) => {
  const { t } = useTranslation();
  const { form } = useACHLocationForm();
  const navigate = useNavigate();
  const [copyACHLocation, { isLoading }] = useCopyACHLocationMutation();
  const submit = async data => {
    await copyACHLocation({
      fromLocationId: data.location,
      toLocationId: locationId,
    });
    close();
    navigate(`/giftcards/moneymovement/${locationId}`);
  };

  const cancel = () => {
    close();
  };

  return (
    <FormDrawer
      title={t('drawer.copyACHSettings.title')}
      subtitle={t('drawer.copyACHSettings.copyFrom.subtitle')}
      data-testid="ACHCopyFromDrawer.Drawer"
      open={open}
      onClose={cancel}
      onValid={submit}
      cancel={cancel}
      formMethods={form}
      submitButtonLabel={t('drawer.copyACHSettings.submitLabel')}
      isLoading={isLoading}
    >
      <ACHCopyLocationForm
        label={t('drawer.copyACHSettings.copyFrom.autocomplete.label')}
        data-testid="ACHCopyFromDrawer.AutocompleteField"
        isCopyFrom
      />
    </FormDrawer>
  );
};

export default ACHCopyFromDrawer;
